function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobCreditAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9860"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9859"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46095",
    d: "M191.308 359.307c1.164-1.173 2.287-2.391 3.5-3.507a2.471 2.471 0 0 1 4.1 1.339 2.814 2.814 0 0 1-.532 2.167c-1.6 2.328-3.178 4.672-4.843 6.953a4.953 4.953 0 0 1-4.165 2.115h-9.046a1.7 1.7 0 0 0-1.339.54c-.157.011-.234-.113-.324-.2q-3.327-3.329-6.649-6.662c-.091-.091-.213-.168-.206-.324.53-.454.994-.976 1.516-1.44a5.493 5.493 0 0 1 3.724-1.5q5.6-.014 11.2 0a2.6 2.6 0 0 1 2.158 1.039c.061.078.115.168.237.152a2.738 2.738 0 0 1-.527 3.566 2.565 2.565 0 0 1-1.8.667c-1.861.006-3.722 0-5.583 0a1.7 1.7 0 0 0-.4.02.4.4 0 0 0-.336.433.4.4 0 0 0 .334.4 1.615 1.615 0 0 0 .364.02h5.55a3.633 3.633 0 0 0 3.676-3.331 3.509 3.509 0 0 0-.458-2.082.866.866 0 0 1-.151-.365z",
    transform: "translate(-167.021 -341.713)",
    style: {
      fill: "#fcd4a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46096",
    d: "m122.734 420.634 7.18 7.19c.207.215.419.427.621.646a.527.527 0 0 1 0 .822q-1.554 1.573-3.124 3.131c-.291.289-.564.259-.891-.068q-1.87-1.869-3.736-3.741l-4.535-4.542c-.4-.406-.406-.634 0-1.037q1.467-1.472 2.936-2.942c.393-.394.6-.39 1.006.008.176.18.36.356.543.533z",
    transform: "translate(-117.944 -400.622)",
    style: {
      fill: "#fe6b6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46097",
    d: "M228.715 211.557a7.45 7.45 0 1 1-7.439-7.467 7.47 7.47 0 0 1 7.439 7.467z",
    transform: "translate(-205.29 -204.09)",
    style: {
      fill: "#fce64c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46098",
    d: "M294.372 401.968a2.545 2.545 0 0 1 .657 1.386 3.506 3.506 0 0 1-.4 2.562 3.645 3.645 0 0 1-2.636 1.861 8.59 8.59 0 0 1-1.488.056c-1.639.009-3.279 0-4.918 0-.4 0-.661-.213-.655-.539s.256-.526.668-.527h5.815a2.65 2.65 0 0 0 2.361-3.8c-.052-.106-.142-.206-.069-.339a4.986 4.986 0 0 1 .665-.66z",
    transform: "translate(-270.085 -384.374)",
    style: {
      fill: "#fccd96"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46099",
    d: "M232.117 228.848a6.4 6.4 0 1 1 6.411-6.309 6.4 6.4 0 0 1-6.411 6.309z",
    transform: "translate(-216.166 -214.984)",
    style: {
      fill: "#febb42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46100",
    d: "M276.354 229.074a1.217 1.217 0 0 1 0 .2c-.055.331.077.5.392.643a2.079 2.079 0 0 1 1.2 1.717c.054.407-.141.676-.475.706s-.552-.181-.585-.6a1.065 1.065 0 1 0-1.08 1.135 2.128 2.128 0 0 1 2.136 2.2 2.022 2.022 0 0 1-1.327 1.9.344.344 0 0 0-.264.388c.013.277.009.555 0 .833a.531.531 0 1 1-1.061-.006 3.243 3.243 0 0 0-.036-1.023c-.113-.293-.555-.3-.8-.529a2.152 2.152 0 0 1-.757-1.528c-.017-.4.187-.624.522-.628s.512.2.539.581a1.016 1.016 0 0 0 .676.941 1.064 1.064 0 1 0 .392-2.055 2.11 2.11 0 0 1-2.124-2.2 2.054 2.054 0 0 1 1.308-1.883.393.393 0 0 0 .285-.443 7.624 7.624 0 0 1 0-.8.531.531 0 1 1 1.061-.009c.004.149-.003.304-.002.46z",
    transform: "translate(-259.847 -225.942)",
    style: {
      fill: "#febb42"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46101",
    d: "M9.613-88.224H8.5a2.213 2.213 0 0 0-.36-.92h1.194l.286-1.041H4.445l-.305 1.21h1.471a1.309 1.309 0 0 1 1.378.748H4.421L4.139-87.2h2.89a1.32 1.32 0 0 1-1.417.869H4.257v.869L7-82.164h1.634v-.07l-2.475-3.034.047-.016A2.3 2.3 0 0 0 8.5-87.2h.838z",
    transform: "translate(9.126 93.625)",
    style: {
      fill: "#fce64c"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobCreditAvailable);
export default __webpack_public_path__ + "static/media/mobCREDITAvailable.065fc3b736128ec6d53ff2a78b791f44.svg";
export { ForwardRef as ReactComponent };